import { render, staticRenderFns } from "./ShowMixes.vue?vue&type=template&id=6c8f25e4&scoped=true&"
import script from "./ShowMixes.vue?vue&type=script&lang=js&"
export * from "./ShowMixes.vue?vue&type=script&lang=js&"
import style0 from "./ShowMixes.vue?vue&type=style&index=0&id=6c8f25e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8f25e4",
  null
  
)

export default component.exports